import { gl } from '../../../Engine';
import { Uniform } from './Uniform';

export class UniformSampler extends Uniform {
    constructor(name: string) {
        super(name);
    }

    loadTextureUnit(value: number) {
        if (this.location) {
            gl.uniform1i(this.location, value);
        }
    }
}
